var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"anchor",staticClass:"tooltip"},[_c('span',[_vm._v(" "+_vm._s(_vm.anchor))]),_c('div',{ref:"content",staticClass:"content",staticStyle:{"display":"none"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }